import {
    START_ORDER,
    SET_ITEM_TO_CART,
    SET_ITEM_TO_CONSTRUCTION,
    SET_ORDER_TYPE,
    SET_ORDER_TIP,
    SAVE_DELIVERY_INFO,
    SET_CUSTOMER_INFO,
    SET_REMARK_TO_ORDER,
    REMOVE_ITEM_FROM_CART,
    REMOVE_ITEM_FROM_CONSTRUCTION,
    CLEAR_CART_ITEM_ANIMATION,
    RESET_CART,
    TRIGGER_UPSELL,
    END_UPSELL,
} from './types';

export const startOrder = order => {
    return {
        type: START_ORDER,
        payload: order,
    };
};

export const setOrderType = (orderType) => {
    return {
        type: SET_ORDER_TYPE,
        payload: orderType,
    };
};

export const setOrderTip = (percentage) => {
    return {
        type: SET_ORDER_TIP,
        payload: percentage,
    };
};

export const setItemToConstruction = cartItem => {
    return {
        type: SET_ITEM_TO_CONSTRUCTION,
        payload: cartItem,
    };
};

export const removeItemFromConstruction = () => {
    return {
        type: REMOVE_ITEM_FROM_CONSTRUCTION
    };
};

export const setItemToCart = (cartItem, animate = true) => {
    return dispatch => {
        dispatch({
            type: SET_ITEM_TO_CART,
            payload: cartItem,
            meta: { animate, replace: cartItem.index >= 0 }
        });

        setTimeout(() => dispatch(triggerUpsell(cartItem.id)), 1500);

        setTimeout(() => dispatch({ type: CLEAR_CART_ITEM_ANIMATION, payload: cartItem }), 2000);
    };
};

export const removeItemFromCart = cartItem => {
    return {
        type: REMOVE_ITEM_FROM_CART,
        payload: cartItem
    };
};

export const resetCart = () => {
    return {
        type: RESET_CART
    };
};

export const saveDeliveryInfo = deliveryInfo => {
    return {
        type: SAVE_DELIVERY_INFO,
        payload: deliveryInfo,
    };
};

export const setCustomerInfo = customer => {
    return {
        type: SET_CUSTOMER_INFO,
        payload: customer
    };
};

export const setRemarkToOrder = remarks => {
    return {
        type: SET_REMARK_TO_ORDER,
        payload: remarks
    };
};

export const triggerUpsell = trigger => {
    return { type: TRIGGER_UPSELL, payload: trigger };
};

export const endUpsell = trigger => {
    return { type: END_UPSELL, payload: trigger };
};
